export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20diverse%20fashion%20products%20including%20colorful%20sneakers%20leather%20bag%20watch%20sunglasses%20and%20denim%20jacket%20artfully%20arranged%20on%20warm%20terracotta%20colored%20linen%20fabric%2C%20top%20down%20view%2C%20bright%20natural%20daylight%2C%20vibrant%20earthy%20palette%2C%20editorial%20catalog%20photography%2C%20rich%20textures%2C%20dynamic%20composition%20with%20diagonal%20arrangement&width=1800&height=1200&seq=hero-bg-v2-01&orientation=landscape"
          alt="OOPBuy Spreadsheet product categories showcase"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
        <div className="absolute inset-0 bg-gradient-to-tr from-amber-900/10 via-transparent to-rose-900/10 backdrop-blur-[2px]"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-[900px] mx-auto text-center pt-16">
        <p className="animate-fade-in-up text-xs md:text-sm font-semibold text-white/70 uppercase tracking-[0.2em] mb-6 font-label">
          Discover &amp; Compare
        </p>

        <h1 className="animate-fade-in-up animate-delay-100 text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] font-heading">
          THE COMPLETE
          <br />
          <span className="font-display italic font-medium text-3xl md:text-5xl lg:text-6xl">
            OOPBuy Spreadsheet
          </span>
          <br />
          HUB FOR 2026
        </h1>

        <p className="animate-fade-in-up animate-delay-200 mt-8 text-base md:text-lg text-white/80 font-light max-w-[600px] mx-auto leading-relaxed">
          Discover, compare, and analyze the most updated OOPBuy spreadsheets designed for smarter product sourcing, dropshipping operations, and e-commerce growth.
        </p>

        <div className="animate-fade-in-up animate-delay-300 mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center h-14 px-8 rounded-full bg-background-50 text-foreground-950 text-base font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer w-[220px]"
          >
            Explore Spreadsheet List
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center h-14 px-8 rounded-full bg-foreground-950 text-background-50 text-base font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer w-[220px]"
          >
            Compare Spreadsheets
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center h-14 px-8 rounded-full border-2 border-white/30 text-white text-base font-semibold hover:bg-white/10 hover:border-white/50 transition-all duration-200 whitespace-nowrap cursor-pointer w-[220px]"
          >
            Visit Main Platform
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <span className="text-white/50 text-xs font-label tracking-wider">SCROLL</span>
        <div className="w-[1px] h-8 bg-gradient-to-b from-white/40 to-transparent"></div>
      </div>
    </section>
  );
}